export default __webpack_public_path__ + "static/media/me2.a0e42cc8.jpg";